<template>
    <div>
        <div class='mcf-page-background'></div>
        <div class="mcf-page-editor">
            <div class="mcf-page-editor-form">
                <div class="mcf-page-editor-header">
                    <label>Créer une facture d'acompte</label>
                </div>
                <div class="mcf-page-editor-menu">
                    <button @click="bt_save">
                        <i class="fa fa-save"></i>
                        <label>Facturer</label>
                    </button>
                    <button @click="bt_cancel">
                        <i class="fa fa-close"></i>
                        <label>Annuler</label>
                    </button>
                </div>
                <div class="mcf-page-editor-content">
                    <div class="mcf-page-editor-title">
                        <label><i class='fa fa-circle-info'></i> Acompte</label>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-choice">
                            <label>Acompte</label>
                            <input type="number" v-model="o.vamount" placeholder="">
                            <span @click="o.vtype='MONEY'" v-if="o.vtype=='PERCENT'">%</span>
                            <span @click="o.vtype='PERCENT'" v-if="o.vtype=='MONEY'">€</span>
                        </div>
                        <div class="mcf-page-editor-column-text">
                            <label>Montant</label>
                            <input type="number" v-model="total">
                        </div>
                    </div>
                    <div class="mcf-page-editor-line-1">
                        <label>{{txtmessage}}</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import {DateTime} from "luxon";

export default {
    props:{
        account:Object,
        sale:Object,
        line:Object,
        cancel:Function,
        save:Function
    },
    data(){
        return {
            o: this.line,
            txtmessage:''
        };
    },
    computed: {
        total: function(){
            var tmain = this;
            var ret = 0;
            var vamount = parseFloat(tmain.o.vamount,2);
            if (tmain.o.vtype == 'PERCENT'){
                ret = parseFloat(tmain.sale.total_ttc * (vamount / 100),2);
            }
            if (tmain.o.vtype == 'MONEY'){
                ret = vamount;
            }
            ret = ret.toFixed(2);
            return ret;
        }
    },
    created() {
        
    },
    methods:{
        bt_cancel:function(){
            this.cancel();
        },
        bt_save:function(){
            var tmain = this;
            var nb = tmain.total;
            tmain.txtmessage = "";
            var formatter = new Intl.NumberFormat(tmain.account.lang, {style: 'currency',currency: 'EUR',minimumFractionDigits: 2,maximumFractionDigits:2});
            if (nb>0){
                if (tmain.sale.total_ttc>nb){
                    tmain.o.advance = nb;
                    tmain.save(tmain.o);
                }else{
                    tmain.txtmessage = "Nous ne pouvons pas créer votre facture d'acompte. Le montant de votre facture d'acompte ("+formatter.format(nb)+") est supérieur ou égal au total de votre document ("+ formatter.format(tmain.sale.total_ttc)+").";
                }
            }else{
                tmain.txtmessage = "Veuillez définir votre acompte en pourcentage ou en monétaire.";
            }     
        }
    }
}
</script>